import $ from 'jquery'

const HEADER_COMPACT_ENTER_PX = 12;
const HEADER_COMPACT_EXIT_PX = 3;

const el = $( '.header-sticky' );
let lastScrollTop = 0;
let headerCompact;

function syncHeaderFromScroll( scrollTop ) {
	const y = Math.round( scrollTop );
	let next;
	if ( y >= HEADER_COMPACT_ENTER_PX ) {
		next = true;
	} else if ( y <= HEADER_COMPACT_EXIT_PX ) {
		next = false;
	} else {
		next = headerCompact === undefined ? true : headerCompact;
	}
	if ( next === headerCompact ) {
		return;
	}
	headerCompact = next;
	if ( headerCompact ) {
		el.removeClass( 'header-initial-pos' ).addClass( 'header-scrolled-pos' );
	} else {
		el.removeClass( 'header-scrolled-pos' ).addClass( 'header-initial-pos' );
	}
}

syncHeaderFromScroll( $( window ).scrollTop() );

$( window ).on( 'scroll', function () {
	const scrollTop = $( this ).scrollTop();

	syncHeaderFromScroll( scrollTop );

	if ( scrollTop > 0 ) {
		if ( scrollTop > lastScrollTop ) {
			$( 'body' ).removeClass( 'scroll-up' ).addClass( 'scroll-down' );
		} else {
			$( 'body' ).removeClass( 'scroll-down' ).addClass( 'scroll-up' );
		}
	}

	lastScrollTop = scrollTop;
} );
